import styled from 'styled-components';

export const StyledContainer = styled.div`
	h2 {
		text-align: center;
	}
	width: 30%;
	margin: auto;
	padding: 32px;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		width: 50%;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		width: 70%;
	}
`;

export const StyledOffice365Button = styled.button`
	background: ${(props) => props.theme.colors.background};
	border: none;
	padding: 0;
	font-size: 15px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 12px;
	color: ${(props) => props.theme.colors.text};
	outline-style: none;
`;

export const StyledTitleContainer = styled.div`
	margin-top: 12px;
	margin-bottom: 24px;
`;
export const StyledError = styled.p`
	color: ${({ theme }) => theme.colors.error};
`;
export const StyledBlock = styled.span`
	width: 100%;
	display: inline-block;
	position: relative;
`;
export const StyledVersionContainer = styled.div`
	display: flex;
	flex-direction: column;
	color: ${({ theme }) => theme.colors.muted};
	font-size: 14px;
`;
export const StyledModifyPassword = styled.div`
	color: ${({ theme }) => theme.colors.muted};
	text-decoration: underline;
	display: inline-block;
	position: relative;
	margin: 15px;
	cursor: pointer;
`;
export const StyledMailForm = styled.div`
	display: flex;
	flex-direction: column;
	color: ${({ theme }) => theme.colors.muted};
	font-size: 14px;
`;
export const StyledSuccess = styled.p`
	color: ${({ theme }) => theme.colors.success};
	text-align: center;
`;
export const StyledText = styled.p`
	color: ${({ theme }) => theme.colors.muted};
	text-align: center;
	margin-bottom: 24px;
	font-size: 15px;
`;
export const StyledGoBack = styled.div`
	color: ${({ theme }) => theme.colors.muted};
	text-decoration: underline;
	text-align: center;
	margin: 25px;
	cursor: pointer;
`;
